module.exports = __webpack_public_path__ + "static/financial_access1-b717e2d0ef6f067c0ccbf52a0ec9e305.png";